import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Button } from "nlib/ui";
import { getCurrentQuickBooksRealmId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import React, { useCallback } from "react";
import RoboticAiStatuses from "const/RoboticAiStatuses";
import useEnvVars from "hooks/useEnvVars";

const ICONS = {
  [RoboticAiStatuses.AWAITING_CATEGORIZATION]: Icons.Question,
  [RoboticAiStatuses.AWAITING_CLARIFICATION]: Icons.WarningCircle,
  [RoboticAiStatuses.AWAITING_REVIEW]: Icons.Eye,
  [RoboticAiStatuses.AWAITING_DOCUMENT]: Icons.FileMagnifyingGlass,
  [RoboticAiStatuses.AWAITING_EXPORT]: Icons.UploadSimple,
  [RoboticAiStatuses.AWAITING_RECONCILIATION]: Icons.Clock
};

const ProgressCell = ({ transactionId, roboticAiStatus = RoboticAiStatuses.UNKNOWN }) => {
  const [, setEnvVars] = useEnvVars();

  const { uiTexts } = useSelector(getTextsData);

  const quickBooksBusiness = !!useSelector(getCurrentQuickBooksRealmId);

  const [, progressStep] = roboticAiStatus.split(":");

  const Icon = ICONS[roboticAiStatus];

  const label = quickBooksBusiness && roboticAiStatus === RoboticAiStatuses.AWAITING_RECONCILIATION
    ? uiTexts.awaitingMatching
    : uiTexts[progressStep] || uiTexts.unknown;

  const handleAdditionalInfoClick = useCallback(() => {
    setEnvVars({ transactionId });
  }, [transactionId, setEnvVars]);

  return (
    <div className={Css.progressCell}>
      <Button outline className={Css.viewDetails} icon={Icons.Eye} onClick={handleAdditionalInfoClick}>
        {uiTexts.viewDetails}
      </Button>
      <div className={Css.progressStatus} title={label} data-step={progressStep}>
        {Icon && <Icon />}
        <span className={Css.label}>{label}</span>
        <span>
          <Icons.CircleNotch data-wait />
        </span>
      </div>
    </div>
  );
};

export default React.memo(ProgressCell);
